import '../assets/Steps.css';
import { h, defineComponent, ref, computed, onMounted, openBlock, createElementBlock, normalizeStyle, createVNode, Fragment, renderList, normalizeClass, unref, createCommentVNode, createElementVNode, useCssVars, inject, watchEffect, onBeforeUnmount, toDisplayString, defineAsyncComponent, createBlock, mergeProps, toRaw, isRef, withKeys, withModifiers, renderSlot, nextTick, withCtx, createTextVNode, watch, Transition, resolveDynamicComponent } from 'vue';
import { e as ToolModuleKind, A as AgentActionKind, T as TextTransform, P as PerkLayoutKind, D as DeviceKind, o as CountdownSize, a as ToolLayoutKind, C as CountdownKind, q as FormFieldsPosition, r as FormSelectionKind, s as FormFieldKind, c as TermsLinkKind, L as LoginStep, t as AgentActionLoginStep, g as DefaultStep, b as ToolKind } from './maps.nxkzRTum.js';
import { u as useElementSize } from './index.Cp00ESn6.js';
import { u as useI18n } from './widgets-core.es.C7uAbUpp.js';
import { o as useStore, B as ButtonState, e as appendPx, l as parseTimeLeft, $ as $e } from './useStore.B0k3KXLh.js';
import { a as useTextAppearance, _ as _sfc_main$i, b as _sfc_main$j, s as stepsWrapper } from './Text.vue_vue_type_style_index_0_lang.CFVGfjC7.js';
import { _ as _sfc_main$f } from './Input.vue_vue_type_style_index_0_lang.BUF5eiwo.js';
import { _ as _sfc_main$g } from './Terms.vue_vue_type_style_index_0_lang.ajCdgFNb.js';
import { _ as _sfc_main$h } from './Tooltip.vue_vue_type_style_index_0_lang.Xu8bM845.js';
import { _ as _export_sfc } from './_plugin-vue_export-helper.pcqpp-6-.js';

const icon = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M4.166 5a8.25 8.25 0 1111.668 11.667A8.25 8.25 0 014.166 4.999zM10 4.082a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zm-.75 4.25a.75.75 0 01.75-.75h.008a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75zm-.833 2.5a.75.75 0 01.75-.75H10a.75.75 0 01.75.75v2.583h.083a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75v-2.583h-.083a.75.75 0 01-.75-.75z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

var StepState = /* @__PURE__ */ ((StepState2) => {
  StepState2["Active"] = "active";
  StepState2["Next"] = "next";
  StepState2["Previous"] = "previous";
  return StepState2;
})(StepState || {});

const _hoisted_1$c = ["data-module-id"];
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "EmailCapture",
  props: {
    moduleProps: {}
  },
  setup(__props) {
    const moduleKindButtonKindMap = {
      [ToolModuleKind.SavedSearch]: AgentActionKind.SendSaveSearch,
      [ToolModuleKind.EmailCapture]: AgentActionKind.SendSubscribe
    };
    const store = useStore();
    const props = __props;
    const emailRef = ref();
    const termsRef = ref(null);
    const emailValue = ref("");
    const propertyTerms = computed(() => store?.extraData.defaultAssets?.terms || []);
    const termsArray = computed(() => props.moduleProps.terms.customTerms);
    const isTermRequired = computed(() => props.moduleProps.terms.isTermRequired);
    const isTermsInheritedFromProperty = computed(
      () => props.moduleProps.terms.isTermsInheritedFromProperty
    );
    const errorMessage = computed(
      () => store?.literals.getLiteral(
        emailValue.value ? "Error: Please enter a valid email address (e.g. name@example.com)." : "Error: Email address is required"
      )
    );
    const placeholder = computed(() => store?.literals.getLiteral("Your email"));
    const sending = computed(() => store?.handlers.buttonState === ButtonState.Sending);
    const appearanceStyle = computed(() => useTextAppearance(props.moduleProps.appearance, store?.device));
    function validate() {
      if (emailRef.value && termsRef.value) {
        const emailValid = emailRef.value.validate();
        if (emailValid) {
          const termsValid = termsRef.value.validate();
          if (termsValid.valid) {
            return {
              emailAddress: emailValue.value,
              terms: termsValid.terms
            };
          }
        }
      }
      return false;
    }
    onMounted(() => {
      store?.handlers.setDataValidator(moduleKindButtonKindMap[props.moduleProps.moduleType], validate);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-emailcapture",
        "data-module-id": _ctx.moduleProps.id,
        style: normalizeStyle(appearanceStyle.value)
      }, [
        createVNode(_sfc_main$f, {
          class: "thn--tool-emailcapture__input",
          ref_key: "emailRef",
          ref: emailRef,
          type: "email",
          modelValue: emailValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => emailValue.value = $event),
          placeholder: placeholder.value,
          "error-message": errorMessage.value,
          disabled: !!sending.value,
          required: true,
          id: "email-capture"
        }, null, 8, ["modelValue", "placeholder", "error-message", "disabled"]),
        createVNode(_sfc_main$g, {
          class: "thn--tool-emailcapture__terms",
          ref_key: "termsRef",
          ref: termsRef,
          disabled: !!sending.value,
          "custom-terms": termsArray.value,
          "property-terms": propertyTerms.value,
          "terms-inherited": isTermsInheritedFromProperty.value,
          "terms-required": isTermRequired.value,
          "appearance-style": appearanceStyle.value
        }, null, 8, ["disabled", "custom-terms", "property-terms", "terms-inherited", "terms-required", "appearance-style"])
      ], 12, _hoisted_1$c);
    };
  }
});

const _hoisted_1$b = ["data-module-id"];
const _hoisted_2$9 = {
  key: 0,
  class: "thn--tool-perks__bullet"
};
const _hoisted_3$7 = ["data-horizontal-layout"];
const _hoisted_4$6 = ["innerHTML"];
const _hoisted_5$4 = ["onMouseover", "onMouseout"];
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "Perks",
  props: {
    moduleProps: {},
    isHorizontalLayout: { type: Boolean }
  },
  setup(__props) {
    const store = useStore();
    const props = __props;
    const tooltipRefs = ref({});
    const isTitleCase = computed(() => {
      const otherTextTransform = store?.styles.fonts.perks?.textTransform;
      return otherTextTransform === TextTransform.Titlecase;
    });
    const appearanceStyle = computed(() => useTextAppearance(props.moduleProps.appearance, store?.device));
    const inherited = computed(() => props.moduleProps.isPerksInheritedFromProperty);
    const perksList = computed(() => inherited.value ? store?.extraData.defaultAssets?.perks : props.moduleProps.perks);
    function onOverIcon(target, perkId) {
      const perkData = perksList.value?.find((perk) => perk.perkId === perkId);
      const tooltipMessage = perkData && perkData.perk.tooltipInfo && store?.literals.getPerkTooltipLiteral(perkData.perk.tooltipInfo);
      const {
        left,
        top,
        width
      } = target.getBoundingClientRect();
      tooltipRefs.value[perkId].show(tooltipMessage, {
        left: left + width / 2,
        top
      });
    }
    function getLocalePerkDescription(perkData) {
      if (store && perkData.description) {
        return store.literals.getPerkActiveLiteral(perkData.description, isTitleCase.value);
      }
      return perkData.name;
    }
    function onOutIcon(perkId) {
      tooltipRefs.value[perkId].hide();
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: "thn--tool-perks",
        "data-module-id": _ctx.moduleProps.id,
        style: normalizeStyle(appearanceStyle.value)
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(perksList.value, ({ perkId, perk }) => {
          return openBlock(), createElementBlock("li", {
            class: normalizeClass({
              "thn--tool-perks__perk": true,
              "highlights": _ctx.moduleProps.appearance?.layout === "highlights"
            }),
            key: perkId
          }, [
            _ctx.moduleProps.appearance?.layout === unref(PerkLayoutKind).Bullets ? (openBlock(), createElementBlock("div", _hoisted_2$9)) : createCommentVNode("", true),
            createElementVNode("div", {
              class: "thn--tool-perks__label",
              "data-horizontal-layout": _ctx.isHorizontalLayout
            }, [
              createElementVNode("span", {
                class: "thn--tool-perks__label-text",
                innerHTML: getLocalePerkDescription(perk)
              }, null, 8, _hoisted_4$6),
              !!perk.tooltipInfo ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: "thn--tool-perks__icon",
                onMouseover: (ev) => onOverIcon(ev.target, perkId),
                onMouseout: () => onOutIcon(perkId)
              }, [
                createVNode(unref(icon)),
                createVNode(_sfc_main$h, {
                  class: "thn--tool-perks__tooltip",
                  ref_for: true,
                  ref: (ref2) => tooltipRefs.value[perkId] = ref2,
                  "back-color": "#ffffff",
                  color: "#000000"
                }, null, 512)
              ], 40, _hoisted_5$4)) : createCommentVNode("", true)
            ], 8, _hoisted_3$7)
          ], 2);
        }), 128))
      ], 12, _hoisted_1$b);
    };
  }
});

const countdownFontSizes = {
  [DeviceKind.Desktop]: {
    [CountdownSize.Compact]: {
      number: 14,
      label: 14
    },
    [CountdownSize.Normal]: {
      number: 36,
      label: 14
    }
  },
  [DeviceKind.Mobile]: {
    [CountdownSize.Compact]: {
      number: 14,
      label: 14
    },
    [CountdownSize.Normal]: {
      number: 24,
      label: 12
    }
  }
};

const _hoisted_1$a = ["data-module-id", "data-style", "data-size"];
const _hoisted_2$8 = { class: "thn--tool-countdown__number" };
const _hoisted_3$6 = { class: "thn--tool-countdown__label" };
const _hoisted_4$5 = ["title"];
const _hoisted_5$3 = { key: 1 };
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "Countdown",
  props: {
    moduleProps: {}
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "5810b8d9": unref(appendPx)(unref(countdownFontSizes).desktop.normal.number),
      "1714f5bc": unref(appendPx)(unref(countdownFontSizes).desktop.normal.label),
      "582d2556": unref(appendPx)(unref(countdownFontSizes).desktop.compact.number),
      "2355c1c0": unref(appendPx)(unref(countdownFontSizes).desktop.compact.label),
      "40bc59b7": unref(appendPx)(unref(countdownFontSizes).mobile.compact.number),
      "5022c11e": unref(appendPx)(unref(countdownFontSizes).mobile.compact.label),
      "f6448f92": unref(appendPx)(unref(countdownFontSizes).mobile.normal.number),
      "6b1b929e": unref(appendPx)(unref(countdownFontSizes).mobile.normal.label)
    }));
    const store = useStore();
    const props = __props;
    const zeroBlocks = {
      hours: "00",
      minutes: "00",
      seconds: "00"
    };
    const countdownBlocks = ref(zeroBlocks);
    const stoped = ref(true);
    const endTimestamp = ref();
    const paused = ref(false);
    const layout = inject("layout");
    const mustShowLabelAbbreviation = computed(() => props.moduleProps.appearance?.size === "compact" && layout?.value?.type === ToolLayoutKind.StickyImage);
    watchEffect(() => {
      const {
        type,
        details
      } = props.moduleProps;
      const newTimestamp = store?.extraData.countdownTimestamp ? store?.extraData.countdownTimestamp : store?.extraData.getCountdownTimestamp(type, details) || Date.now();
      const {
        builderMode = false,
        countdownInitTime = Date.now()
      } = store?.extraData || {};
      paused.value = builderMode && type === CountdownKind.Time;
      endTimestamp.value = paused.value ? newTimestamp - countdownInitTime : newTimestamp;
    });
    function updateCountdownBlocks() {
      if (!stoped.value) {
        const refTimestamp = Math.round((endTimestamp.value - (!paused.value ? Date.now() : 0)) / 1e3);
        const blocks = parseTimeLeft(refTimestamp);
        if (refTimestamp > 0) {
          countdownBlocks.value = blocks;
          setTimeout(updateCountdownBlocks, 200);
        } else {
          countdownBlocks.value = blocks;
        }
      }
    }
    watchEffect(updateCountdownBlocks);
    onMounted(() => {
      stoped.value = false;
    });
    onBeforeUnmount(() => {
      stoped.value = true;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-countdown",
        "data-module-id": _ctx.moduleProps.id,
        "data-style": _ctx.moduleProps.appearance?.style,
        "data-size": _ctx.moduleProps.appearance?.size
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(countdownBlocks.value, (value, id) => {
          return openBlock(), createElementBlock("div", {
            class: "thn--tool-countdown__block",
            key: id
          }, [
            createElementVNode("p", _hoisted_2$8, toDisplayString(value), 1),
            createElementVNode("div", _hoisted_3$6, [
              mustShowLabelAbbreviation.value ? (openBlock(), createElementBlock("abbr", {
                key: 0,
                title: unref(store)?.literals.getLiteral(id)
              }, toDisplayString(unref(store)?.literals.getLiteralAbb(id)), 9, _hoisted_4$5)) : (openBlock(), createElementBlock("span", _hoisted_5$3, toDisplayString(unref(store)?.literals.getLiteral(id)), 1))
            ])
          ]);
        }), 128))
      ], 8, _hoisted_1$a);
    };
  }
});

const _hoisted_1$9 = ["data-module-id"];
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "Form",
  props: {
    moduleProps: {},
    modalRootContainer: {}
  },
  setup(__props) {
    const store = useStore();
    const props = __props;
    const termsRef = ref(null);
    const viewerRef = ref();
    const FormViewer = defineAsyncComponent(
      // @ts-ignore the lack of TS definitions for this package
      () => import('./form-viewer.umd.CrMpHwy9.js').then(n => n.f)
    );
    const teleportTo = computed(() => props.modalRootContainer ?? "body");
    const sending = computed(() => store?.handlers.buttonState === ButtonState.Sending);
    const propertyTerms = computed(() => store?.extraData.defaultAssets?.terms);
    const termsArray = computed(() => props.moduleProps.terms.customTerms);
    const isTermRequired = computed(() => props.moduleProps.terms.isTermRequired);
    const isTermsInheritedFromProperty = computed(
      () => props.moduleProps.terms.isTermsInheritedFromProperty
    );
    const formValues = ref([]);
    const appearanceStyle = computed(() => useTextAppearance(props.moduleProps.appearance, store?.device));
    const updateValues = (formData) => {
      formValues.value = formData.values;
    };
    const formSchema = computed(() => {
      const {
        name,
        fields,
        fieldsPosition
      } = props.moduleProps;
      const labelDisplayPosition = fieldsPosition === FormFieldsPosition.Out ? 1 : 2;
      return {
        lang: store?.language,
        data: {
          name,
          fields: fields.map((field) => {
            const {
              id,
              type,
              labels,
              hiddenName,
              optional,
              options = [],
              selection = FormSelectionKind.Single,
              defaultOption,
              popupPosition
            } = field;
            const parsedOptions = options.map((option) => ({
              value: option.id,
              label: option.labels
            }));
            const selectionType = selection === FormSelectionKind.Multiple ? "multiSelection" : "oneSelection";
            const parsedType = type === FormFieldKind.Selection ? selectionType : type;
            return {
              type: parsedType,
              default: defaultOption,
              label: labels,
              labelDisplay: hiddenName ? 0 : labelDisplayPosition,
              name: id,
              required: !optional,
              options: parsedOptions,
              popupPosition
            };
          })
        }
      };
    });
    async function validate() {
      if (viewerRef.value && termsRef.value) {
        const formValid = await viewerRef.value.$refs.formRef.validate();
        if (formValid.valid) {
          const termsValid = termsRef.value.validate();
          if (termsValid.valid) {
            return {
              formFields: toRaw(formValues.value),
              terms: termsValid.terms
            };
          }
        }
      }
      return false;
    }
    onMounted(() => {
      store?.handlers.setDataValidator(AgentActionKind.SendForm, validate);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("form", {
        class: "thn--tool-form",
        style: normalizeStyle(appearanceStyle.value),
        "data-module-id": _ctx.moduleProps.id
      }, [
        formSchema.value ? (openBlock(), createBlock(unref(FormViewer), mergeProps({
          key: 0,
          ref_key: "viewerRef",
          ref: viewerRef
        }, formSchema.value, {
          class: "thn--tool-form__viewer",
          "teleport-to": teleportTo.value,
          appearance: _ctx.moduleProps.appearance,
          onChange: updateValues
        }), null, 16, ["teleport-to", "appearance"])) : createCommentVNode("", true),
        createVNode(_sfc_main$g, {
          ref_key: "termsRef",
          ref: termsRef,
          class: "thn--tool-form__terms",
          disabled: !!sending.value,
          "custom-terms": termsArray.value,
          "property-terms": propertyTerms.value,
          "terms-inherited": isTermsInheritedFromProperty.value,
          "terms-required": isTermRequired.value,
          "appearance-style": appearanceStyle.value
        }, null, 8, ["disabled", "custom-terms", "property-terms", "terms-inherited", "terms-required", "appearance-style"])
      ], 12, _hoisted_1$9);
    };
  }
});

const _hoisted_1$8 = ["data-module-id"];
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "Spacer",
  props: {
    moduleProps: {}
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "8fd28c80": heightDesktop.value,
      "6865a27e": heightMobile.value
    }));
    const props = __props;
    const heightDesktop = computed(() => `${props.moduleProps.desktop?.space || 0}px`);
    const heightMobile = computed(() => `${props.moduleProps.mobile?.space || 0}px`);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        role: "none",
        "data-module-id": _ctx.moduleProps.id,
        class: "thn--tool-spacer"
      }, null, 8, _hoisted_1$8);
    };
  }
});

const _hoisted_1$7 = ["data-module-id"];
const _hoisted_2$7 = ["src"];
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "EmbeddedVideo",
  props: {
    moduleProps: {}
  },
  setup(__props) {
    const props = __props;
    const url = computed(() => {
      const source = props.moduleProps?.source;
      if (!source) return null;
      try {
        const _ = new URL(source);
      } catch {
        return null;
      }
      const params = new URLSearchParams();
      if (props.moduleProps.autoplay) {
        params.set("autoplay", "1");
        if (source.includes("vimeo")) {
          params.set("muted", "1");
        } else {
          params.set("mute", "1");
        }
      }
      return `${props.moduleProps.source}?${params.toString()}`;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-video",
        "data-module-id": _ctx.moduleProps.id
      }, [
        createElementVNode("iframe", {
          title: "video",
          src: url.value,
          frameborder: "0",
          allowfullscreen: ""
        }, null, 8, _hoisted_2$7)
      ], 8, _hoisted_1$7);
    };
  }
});

const sending = ref(false);
const moduleProps = ref();
const emailValue = ref("");
const authCodeValue = ref("");
const isAuthCodeRequested = ref(false);
const showValidateError = ref(false);
const useLoginState = () => {
  const store = useStore();
  const sessionId = ref((/* @__PURE__ */ new Date()).getTime().toString());
  const validateError = store?.literals.getLiteral("Invalid code");
  const currentLanguage = computed(() => store?.language || "en");
  const appearanceStyle = computed(() => useTextAppearance(moduleProps.value?.appearance, store?.device));
  const loginTermsContent = computed(() => {
    const privacyPolicy = {
      label: store?.literals.getLiteral("Privacy policy"),
      url: `https://www.thehotelsnetwork.com/${currentLanguage.value}/instant-privacy-policy`
    };
    const agreeTo = store?.literals.getLiteral("I agree to the");
    return `
      ${agreeTo} 
      <a href="${privacyPolicy.url}" target="_blank">${privacyPolicy.label}</a>
    `;
  });
  const propertyTerms = computed(() => store?.extraData.defaultAssets?.terms);
  const isTermsInheritedFromProperty = computed(
    () => moduleProps.value?.terms?.isTermsInheritedFromProperty
  );
  const termsArray = computed(() => [
    {
      termId: "instant-login-terms",
      isRequired: true,
      term: {
        id: "instant-login-terms",
        name: "Instant Login Terms",
        isRequired: true,
        content: {
          linkedTo: TermsLinkKind.CustomUrl,
          htmlContent: loginTermsContent.value
        },
        properties: []
      }
    },
    ...moduleProps.value?.terms?.customTerms || []
  ]);
  const isTermsRequired = computed(() => !!moduleProps.value?.terms?.isTermRequired);
  let buttonModuleCache;
  const buttonModule = computed(() => {
    if (!moduleProps.value?.buttonModule) return buttonModuleCache;
    buttonModuleCache = moduleProps.value?.buttonModule;
    return buttonModuleCache;
  });
  const buttonAppearance = computed(() => buttonModule.value?.appearance);
  const buttonStyle = computed(() => useTextAppearance(buttonModule.value?.appearance, store?.device));
  const currentStep = ref(LoginStep.LoginRegister);
  const resetState = () => {
    authCodeValue.value = "";
    showValidateError.value = false;
    store?.handlers.goBackToMainStep();
  };
  const initModule = (props) => {
    moduleProps.value = props;
    sessionId.value = (/* @__PURE__ */ new Date()).getTime().toString();
    currentStep.value = props.currentView;
  };
  const updateModule = (props) => {
    moduleProps.value = {
      ...moduleProps.value,
      ...props
    };
  };
  function goToSignin() {
    store?.handlers.setStepActive(LoginStep.LoginSignin, DefaultStep.Main);
  }
  function goToRegister() {
    resetState();
    store?.handlers.goBackToMainStep();
  }
  function showError() {
    store?.handlers.setStepActive(DefaultStep.Failure);
  }
  function goToSuccess() {
    resetState();
    store?.handlers.setStepActive(LoginStep.LoginSuccess);
  }
  function goToAuthCode() {
    isAuthCodeRequested.value = true;
    if (store?.handlers.stepActive === LoginStep.LoginRegister || store?.handlers.stepActive === DefaultStep.Main) {
      resetState();
      goToSignin();
    }
  }
  const loginNextAction = {
    [AgentActionLoginStep.Signup]: goToRegister,
    [AgentActionLoginStep.Validation]: goToAuthCode
  };
  const doLoginAction = async (validate) => {
    if (!store) return;
    store.handlers.setDataValidator(AgentActionKind.Login, validate);
    const result = await store.handlers.callHandler(
      AgentActionKind.Login,
      moduleProps.value?.id
    );
    console.log("THN", "useLoginState", "doLoginAction", "result", result);
    if (!result || !result.ok) {
      if (store.handlers.stepActive === LoginStep.LoginSignin && isAuthCodeRequested.value) {
        showValidateError.value = true;
      } else {
        showError();
      }
      return;
    }
    if (result.next) {
      loginNextAction[result.next]();
      return;
    }
    goToSuccess();
  };
  return {
    sending,
    sessionId,
    emailValue,
    currentStep,
    moduleProps,
    authCodeValue,
    validateError,
    showValidateError,
    isAuthCodeRequested,
    termsArray,
    propertyTerms,
    isTermsRequired,
    buttonAppearance,
    buttonModule,
    buttonStyle,
    isTermsInheritedFromProperty,
    appearanceStyle,
    goToSignin,
    initModule,
    goToRegister,
    updateModule,
    doLoginAction
  };
};

const _hoisted_1$6 = { class: "thn--tool-register__form" };
const _hoisted_2$6 = { class: "thn--tool-register__actions" };
const _hoisted_3$5 = ["data-full-width"];
const _hoisted_4$4 = ["innerHTML"];
const _hoisted_5$2 = ["aria-label"];
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "Register",
  setup(__props) {
    const store = useStore();
    const state = useLoginState();
    const {
      emailValue,
      isTermsRequired,
      termsArray,
      appearanceStyle,
      propertyTerms,
      buttonModule,
      buttonStyle,
      buttonAppearance,
      isTermsInheritedFromProperty,
      goToSignin,
      doLoginAction
    } = state;
    const emailRef = ref();
    const termsRef = ref(null);
    const sending = computed(() => store?.handlers.buttonState === ButtonState.Sending || false);
    const errorMessage = computed(() => store?.literals.getLiteral("Please, provide a valid e-mail") || "");
    const placeholder = computed(() => store?.literals.getLiteral("Your email"));
    const registeredMessage = computed(() => store?.literals.getLiteral("Already registered?"));
    const registeredLinkLabel = computed(() => store?.literals.getLiteral("Sign in"));
    const registerLabel = computed(() => {
      if (!buttonModule.value || !store?.device) return "";
      return store?.literals.getActiveModuleText(
        buttonModule.value,
        store?.styles.fonts[ToolModuleKind.Button]?.textTransform === TextTransform.Titlecase
      );
    });
    function validate() {
      if (emailRef.value && termsRef.value) {
        const emailValid = emailRef.value.validate();
        if (emailValid) {
          const termsValid = termsRef.value.validate();
          if (termsValid.valid) {
            return {
              action: AgentActionLoginStep.Signup,
              emailAddress: emailValue.value,
              terms: termsValid.terms
            };
          }
        }
      }
      return false;
    }
    async function loginRegisterHandler() {
      const isValid = validate();
      if (isValid) doLoginAction(validate);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, { class: "thn--tool-register" }), [
        createElementVNode("div", _hoisted_1$6, [
          createVNode(_sfc_main$f, {
            class: "thn--tool-register__input",
            ref_key: "emailRef",
            ref: emailRef,
            type: "email",
            modelValue: unref(emailValue),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(emailValue) ? emailValue.value = $event : null),
            placeholder: placeholder.value,
            "error-message": errorMessage.value,
            required: true,
            style: normalizeStyle(unref(appearanceStyle)),
            disabled: !!sending.value,
            id: "register-email"
          }, null, 8, ["modelValue", "placeholder", "error-message", "style", "disabled"]),
          createVNode(_sfc_main$g, {
            class: "thn--tool-register__terms",
            ref_key: "termsRef",
            ref: termsRef,
            "property-terms": unref(propertyTerms),
            "terms-required": unref(isTermsRequired),
            disabled: !!sending.value,
            "custom-terms": unref(termsArray),
            "terms-inherited": !!unref(isTermsInheritedFromProperty),
            style: normalizeStyle(unref(appearanceStyle))
          }, null, 8, ["property-terms", "terms-required", "disabled", "custom-terms", "terms-inherited", "style"])
        ]),
        createElementVNode("div", _hoisted_2$6, [
          createElementVNode("div", {
            role: "button",
            tabindex: "0",
            class: "thn--tool-button",
            style: normalizeStyle(unref(buttonStyle)),
            "data-full-width": unref(buttonAppearance)?.fullWidth,
            onClick: loginRegisterHandler,
            onKeyup: withKeys(loginRegisterHandler, ["enter"])
          }, [
            _cache[2] || (_cache[2] = createElementVNode("div", { class: "thn--tool-button__back" }, null, -1)),
            createElementVNode("div", {
              class: "thn--tool-button__label",
              innerHTML: registerLabel.value
            }, null, 8, _hoisted_4$4)
          ], 44, _hoisted_3$5),
          createElementVNode("div", {
            class: "thn--tool-register__signin",
            style: normalizeStyle(unref(appearanceStyle))
          }, [
            createElementVNode("span", null, toDisplayString(registeredMessage.value), 1),
            createElementVNode("a", {
              href: "#",
              onClick: _cache[1] || (_cache[1] = withModifiers(
                //@ts-ignore
                (...args) => unref(goToSignin) && unref(goToSignin)(...args),
                ["prevent", "stop"]
              )),
              "aria-label": registeredLinkLabel.value
            }, toDisplayString(registeredLinkLabel.value), 9, _hoisted_5$2)
          ], 4)
        ])
      ], 16);
    };
  }
});

const _sfc_main$7 = {};

function _sfc_render$1(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", mergeProps({
    width: "8",
    height: "16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.548 15.238a.381.381 0 0 0 .27-.65L1.23 8.001l6.587-6.588A.381.381 0 0 0 7.28.875L.42 7.732a.381.381 0 0 0 0 .538l6.858 6.858a.38.38 0 0 0 .27.11h-.001Z",
      fill: "currentColor"
    }, null, -1)
  ]), 16))
}
const BackIcon = /*#__PURE__*/_export_sfc(_sfc_main$7, [['render',_sfc_render$1]]);

const _sfc_main$6 = {};

function _sfc_render(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", mergeProps({
    width: "49",
    height: "48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    createElementVNode("rect", {
      x: ".5",
      width: "48",
      height: "48",
      rx: "24",
      fill: "#D9D9D9"
    }, null, -1),
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.1 24.8a4.405 4.405 0 0 1-4.4-4.4c0-2.426 1.974-4.4 4.4-4.4s4.4 1.974 4.4 4.4-1.974 4.4-4.4 4.4Zm0-8a3.604 3.604 0 0 0-3.6 3.6c0 1.985 1.615 3.6 3.6 3.6s3.6-1.615 3.6-3.6-1.615-3.6-3.6-3.6ZM17.7 32c-.662 0-1.2-.538-1.2-1.2 0-.054.011-1.348.98-2.64.564-.752 1.336-1.35 2.295-1.775 1.171-.521 2.627-.785 4.325-.785 1.698 0 3.154.264 4.325.785.959.426 1.731 1.023 2.295 1.775.969 1.292.98 2.586.98 2.64 0 .662-.538 1.2-1.2 1.2H17.7Zm6.4-5.6c-2.79 0-4.848.762-5.953 2.205-.809 1.056-.845 2.135-.847 2.194v.003a.4.4 0 0 0 .4.398h12.8a.4.4 0 0 0 .4-.4c0-.01-.018-1.114-.847-2.195-1.106-1.443-3.164-2.205-5.953-2.205Z",
      fill: "#fff"
    }, null, -1)
  ]), 16))
}
const UserIcon = /*#__PURE__*/_export_sfc(_sfc_main$6, [['render',_sfc_render]]);

const _hoisted_1$5 = { class: "thn-tool--login__header-back" };
const _hoisted_2$5 = ["aria-label"];
const _hoisted_3$4 = { class: "thn-tool--login__header-back--user-icon" };
const _hoisted_4$3 = { class: "thn-tool--login__header-back--email" };
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "HeaderBack",
  emits: ["goBack"],
  setup(__props) {
    const { t } = $e();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$5, [
        createElementVNode("button", {
          type: "button",
          tabindex: "0",
          class: "thn-tool--login__header-back--button",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("goBack")),
          onKeyup: _cache[1] || (_cache[1] = withKeys(($event) => _ctx.$emit("goBack"), ["enter"])),
          "aria-label": unref(t)("Go back")
        }, [
          createVNode(BackIcon)
        ], 40, _hoisted_2$5),
        createElementVNode("div", _hoisted_3$4, [
          createVNode(UserIcon)
        ]),
        createElementVNode("div", _hoisted_4$3, [
          renderSlot(_ctx.$slots, "default")
        ])
      ]);
    };
  }
});

const _hoisted_1$4 = {
  key: 0,
  class: "thn--tool-signin__auth-code"
};
const _hoisted_2$4 = { class: "thn--tool-signin__auth-code__container" };
const _hoisted_3$3 = ["onInput"];
const _hoisted_4$2 = {
  key: 0,
  class: "thn--tool-signin__auth-code__validate-error"
};
const _hoisted_5$1 = ["aria-label"];
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "AuthCode",
  props: {
    modelValue: {}
  },
  emits: ["validate", "update:modelValue", "resendCode"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const store = useStore();
    const state = useLoginState();
    const {
      showValidateError,
      validateError
    } = state;
    const inputRefs = ref([]);
    const isFullyLoad = ref(false);
    const resendCodeLabel = computed(() => store?.literals.getLiteral("Resend code"));
    const checkAndEmit = () => {
      const allFilled = inputRefs.value.every((input) => input.value.length === 1);
      if (allFilled) {
        const value = inputRefs.value.map((input) => input.value).join("");
        emit("update:modelValue", value);
        emit("validate", value);
      }
    };
    const handleInput = (index) => {
      const currentInput = inputRefs.value[index - 1];
      if (currentInput.value.length === 1) {
        if (index < 6) {
          const nextInput = inputRefs.value[index];
          if (nextInput) {
            nextInput.focus();
          }
        } else {
          inputRefs.value[index - 1].blur();
          checkAndEmit();
        }
      }
    };
    const handlePaste = (event) => {
      const pastedText = event.clipboardData?.getData("text") ?? "";
      if (pastedText.length > 0) {
        const chars = pastedText.slice(0, 6);
        inputRefs.value.forEach(async (input, idx) => {
          input.value = chars[idx] ?? "";
          if (idx < inputRefs.value.length - 1) {
            inputRefs.value[idx + 1].focus();
            await nextTick();
            inputRefs.value[idx + 1].setSelectionRange(0, 1);
          }
        });
        inputRefs.value[inputRefs.value.length - 1].blur();
        checkAndEmit();
      }
    };
    const sendCodeHandler = () => {
      inputRefs.value.forEach((input) => {
        input.value = "";
      });
      showValidateError.value = false;
      emit("update:modelValue", "");
      emit("resendCode");
    };
    onMounted(() => {
      isFullyLoad.value = true;
      inputRefs.value[0]?.focus();
    });
    return (_ctx, _cache) => {
      return isFullyLoad.value ? (openBlock(), createElementBlock("div", _hoisted_1$4, [
        createElementVNode("div", _hoisted_2$4, [
          (openBlock(), createElementBlock(Fragment, null, renderList(6, (index) => {
            return createElementVNode("input", {
              tabindex: "0",
              ref_for: true,
              ref_key: "inputRefs",
              ref: inputRefs,
              key: index,
              class: normalizeClass([
                "code-input",
                unref(showValidateError) && "code-input--error"
              ]),
              maxlength: "1",
              type: "text",
              inputmode: "numeric",
              onFocus: _cache[0] || (_cache[0] = ($event) => $event.target.select()),
              onInput: ($event) => handleInput(index),
              onPaste: handlePaste,
              required: ""
            }, null, 42, _hoisted_3$3);
          }), 64))
        ]),
        unref(showValidateError) ? (openBlock(), createElementBlock("div", _hoisted_4$2, toDisplayString(unref(validateError)), 1)) : createCommentVNode("", true),
        createElementVNode("a", {
          href: "#",
          onClick: withModifiers(sendCodeHandler, ["prevent"]),
          "aria-label": resendCodeLabel.value
        }, toDisplayString(resendCodeLabel.value), 9, _hoisted_5$1)
      ])) : createCommentVNode("", true);
    };
  }
});

const _hoisted_1$3 = { class: "thn--tool-signin__heading" };
const _hoisted_2$3 = {
  role: "heading",
  "aria-level": "1"
};
const _hoisted_3$2 = { class: "thn--tool-signin__form" };
const _hoisted_4$1 = { class: "thn--tool-signin__actions" };
const _hoisted_5 = ["data-full-width", "aria-label"];
const _hoisted_6 = { class: "thn--tool-button__label" };
const _hoisted_7 = ["aria-label"];
const _hoisted_8 = { class: "thn--tool-signin__heading thn--tool-signin__heading--auth-code" };
const _hoisted_9 = {
  role: "heading",
  "aria-level": "1"
};
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "Signin",
  setup(__props) {
    const store = useStore();
    const state = useLoginState();
    const {
      emailValue,
      buttonStyle,
      authCodeValue,
      buttonAppearance,
      isAuthCodeRequested,
      showValidateError,
      appearanceStyle,
      goToSignin,
      goToRegister,
      doLoginAction
    } = state;
    const emailRef = ref();
    const authCodeOpenedFromSignin = ref(false);
    const sending = computed(() => store?.handlers.buttonState === ButtonState.Sending);
    const headingMessage = computed(() => store?.literals.getLiteral("Sign in to your account"));
    const errorMessage = computed(() => store?.literals.getLiteral("Please, provide a valid e-mail"));
    const placeholder = computed(() => store?.literals.getLiteral("Your email"));
    const notRegisteredMessage = computed(() => store?.literals.getLiteral("Not registered yet?"));
    const notRegisteredLinkLabel = computed(() => store?.literals.getLiteral("Register"));
    const signinLabel = computed(() => store?.literals.getLiteral("Sign in"));
    const confirmTourEmailMessage = computed(() => store?.literals.getLiteral("Confirm your email"));
    const enterCodeMessage = computed(() => store?.literals.getLiteral("Enter the validation code sent to your email"));
    function validate() {
      if (emailRef.value) {
        const emailValid = emailRef.value.validate();
        if (emailValid) {
          return {
            action: AgentActionLoginStep.Signin,
            emailAddress: emailValue.value
          };
        }
      }
      return false;
    }
    function validateResend() {
      return {
        action: AgentActionLoginStep.Resend
      };
    }
    function validateAuthCode() {
      if (authCodeValue.value?.length === 6) {
        return {
          action: AgentActionLoginStep.Validation,
          code: authCodeValue.value
        };
      }
      return false;
    }
    const loginSigninHandler = () => {
      authCodeOpenedFromSignin.value = true;
      doLoginAction(validate);
    };
    const resendCodeHandler = async () => {
      await doLoginAction(validateResend);
      isAuthCodeRequested.value = true;
    };
    const validateAuthCodeHandler = () => {
      doLoginAction(validateAuthCode);
    };
    const goBackHandler = () => {
      isAuthCodeRequested.value = false;
      showValidateError.value = false;
      if (authCodeOpenedFromSignin.value) goToSignin();
      else goToRegister();
      authCodeOpenedFromSignin.value = false;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, { class: "thn--tool-signin" }), [
        !unref(isAuthCodeRequested) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createElementVNode("header", _hoisted_1$3, [
            createElementVNode("div", _hoisted_2$3, toDisplayString(headingMessage.value), 1)
          ]),
          createElementVNode("div", _hoisted_3$2, [
            createVNode(_sfc_main$f, {
              class: "thn--tool-signin__input",
              ref_key: "emailRef",
              ref: emailRef,
              type: "email",
              modelValue: unref(emailValue),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(emailValue) ? emailValue.value = $event : null),
              placeholder: placeholder.value,
              "error-message": errorMessage.value,
              disabled: !!sending.value,
              required: true,
              style: normalizeStyle(unref(appearanceStyle)),
              id: "signin-email"
            }, null, 8, ["modelValue", "placeholder", "error-message", "disabled", "style"]),
            createElementVNode("div", _hoisted_4$1, [
              createElementVNode("button", {
                type: "submit",
                tabindex: "0",
                class: "thn--tool-button",
                style: normalizeStyle(unref(buttonStyle)),
                "data-full-width": unref(buttonAppearance)?.fullWidth,
                onClick: loginSigninHandler,
                onKeydown: withKeys(loginSigninHandler, ["enter"]),
                "aria-label": signinLabel.value
              }, [
                _cache[3] || (_cache[3] = createElementVNode("div", { class: "thn--tool-button__back" }, null, -1)),
                createElementVNode("div", _hoisted_6, toDisplayString(signinLabel.value), 1)
              ], 44, _hoisted_5),
              createElementVNode("div", {
                class: "thn--tool-signin__signin",
                style: normalizeStyle(unref(appearanceStyle))
              }, [
                createElementVNode("span", null, toDisplayString(notRegisteredMessage.value), 1),
                createElementVNode("a", {
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = withModifiers(
                    //@ts-ignore
                    (...args) => unref(goToRegister) && unref(goToRegister)(...args),
                    ["prevent", "stop"]
                  )),
                  "aria-label": notRegisteredLinkLabel.value
                }, toDisplayString(notRegisteredLinkLabel.value), 9, _hoisted_7)
              ], 4)
            ])
          ])
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createVNode(_sfc_main$5, { onGoBack: goBackHandler }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(emailValue)), 1)
            ]),
            _: 1
          }),
          createElementVNode("header", _hoisted_8, [
            createElementVNode("div", _hoisted_9, toDisplayString(confirmTourEmailMessage.value), 1),
            createElementVNode("p", null, toDisplayString(enterCodeMessage.value), 1)
          ]),
          createVNode(_sfc_main$4, {
            modelValue: unref(authCodeValue),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => isRef(authCodeValue) ? authCodeValue.value = $event : null),
            onValidate: validateAuthCodeHandler,
            onResendCode: resendCodeHandler
          }, null, 8, ["modelValue"])
        ], 64))
      ], 16);
    };
  }
});

const _hoisted_1$2 = { class: "thn--tool-login__success" };
const _hoisted_2$2 = { class: "thn--tool-login__success__header" };
const _hoisted_3$1 = { class: "thn--tool-login__success__hello" };
const _hoisted_4 = { class: "thn--tool-login__success__email" };
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "LoginSuccess",
  setup(__props) {
    const store = useStore();
    const state = useLoginState();
    const {
      emailValue,
      appearanceStyle
    } = state;
    const helloMessage = computed(() => store?.literals.getLiteral("Hello"));
    const benefitsMessage = computed(() => store?.literals.getLiteral("Exclusive benefits unlocked!"));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$2, [
        createElementVNode("div", _hoisted_2$2, [
          createElementVNode("p", _hoisted_3$1, toDisplayString(helloMessage.value) + ", ", 1),
          createElementVNode("p", _hoisted_4, toDisplayString(unref(emailValue)), 1)
        ]),
        createElementVNode("p", {
          class: "thn--tool-login__success__benefits",
          style: normalizeStyle(unref(appearanceStyle))
        }, toDisplayString(benefitsMessage.value), 5)
      ]);
    };
  }
});

const _hoisted_1$1 = ["data-module-id"];
const _hoisted_2$1 = { class: "thn--tool-login__container" };
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "Login",
  props: {
    moduleProps: {}
  },
  setup(__props) {
    const props = __props;
    const componentViews = {
      [LoginStep.LoginRegister]: _sfc_main$8,
      [LoginStep.LoginSignin]: _sfc_main$3,
      [LoginStep.LoginSuccess]: _sfc_main$2
    };
    const state = useLoginState();
    const {
      initModule,
      updateModule,
      currentStep
    } = state;
    watch(() => props.moduleProps, () => {
      updateModule(props.moduleProps);
    });
    onMounted(() => {
      initModule(props.moduleProps);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-login",
        "data-module-id": props.moduleProps?.id
      }, [
        createElementVNode("div", _hoisted_2$1, [
          createVNode(Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: withCtx(() => [
              (openBlock(), createBlock(resolveDynamicComponent(componentViews[unref(currentStep)])))
            ]),
            _: 1
          })
        ])
      ], 8, _hoisted_1$1);
    };
  }
});

const _hoisted_1 = ["can-animate", "aria-label"];
const _hoisted_2 = ["state", "data-add-module", "data-vertical-center", "data-image-position", "data-horizontal-layout", "data-align", "inert"];
const _hoisted_3 = {
  key: 0,
  class: "thn--tool-steps__text-container"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Steps",
  props: {
    steps: {},
    texts: {},
    hasExtraSteps: {},
    maxHeight: {},
    toolKind: {},
    layoutKind: {},
    layout: {},
    imagePosition: {},
    isHorizontalLayout: { type: Boolean, default: false },
    moduleAlign: {},
    modalRootContainer: {}
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "334fae26": innerHeigth.value
    }));
    const { t } = useI18n();
    const moduleKindToComponentMap = {
      [ToolModuleKind.Heading]: _sfc_main$i,
      [ToolModuleKind.Paragraph]: _sfc_main$i,
      [ToolModuleKind.SavedSearch]: _sfc_main$e,
      [ToolModuleKind.EmailCapture]: _sfc_main$e,
      [ToolModuleKind.Button]: _sfc_main$j,
      [ToolModuleKind.Perks]: _sfc_main$d,
      [ToolModuleKind.Countdown]: _sfc_main$c,
      [ToolModuleKind.Form]: _sfc_main$b,
      [ToolModuleKind.Spacer]: _sfc_main$a,
      [ToolModuleKind.Login]: _sfc_main$1,
      [ToolModuleKind.EmbeddedVideo]: _sfc_main$9
    };
    const store = useStore();
    const props = __props;
    const rootDom = ref();
    const stepActiveDom = computed(() => rootDom.value?.querySelector(`.thn--tool-steps__step--${store?.handlers.stepActive}`));
    const stepIds = computed(() => Object.keys(props.steps));
    const { height: stepHeight } = useElementSize(stepActiveDom);
    const innerHeigth = computed(() => props.toolKind === ToolKind.Inliner ? "0" : "100%");
    const rootStyle = computed(() => {
      let padding = parseInt(store?.styles.getCssVariableValue("--step-padding") || "10", 10);
      padding = props.layoutKind === ToolLayoutKind.LowerNotification ? padding * 2 + 5 : padding;
      let stepH = stepHeight.value + 2 * padding;
      if (props.maxHeight) {
        stepH = Math.min(props.maxHeight, stepH);
      }
      return {
        height: props.layoutKind === ToolLayoutKind.SquareImage && props.toolKind !== ToolKind.Inliner ? "100%" : appendPx(stepH),
        overflowY: store?.handlers.isFirstStep ? "auto" : "hidden"
      };
    });
    const containerStyle = computed(() => {
      let stepH;
      if (stepHeight.value < 320) {
        stepH = stepHeight.value;
      } else if (stepHeight.value >= 320 && stepHeight.value < 450) {
        stepH = stepHeight.value + stepHeight.value * 0.35;
      } else if (stepHeight.value >= 450 && stepHeight.value < 650) {
        stepH = stepHeight.value + stepHeight.value * 0.55;
      } else {
        stepH = stepHeight.value + stepHeight.value * 0.65;
      }
      return {
        height: appendPx(stepH)
      };
    });
    function getModuleComponent(moduleKind) {
      return moduleKindToComponentMap[moduleKind] || "div";
    }
    function getStepState(stepId) {
      switch (true) {
        case store?.handlers.stepActive === stepId:
          return StepState.Active;
        case store?.handlers.stepPrevious === stepId:
          return StepState.Previous;
        default:
          return StepState.Next;
      }
    }
    onMounted(() => {
      stepsWrapper.value = rootDom.value;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-steps",
        ref_key: "rootDom",
        ref: rootDom,
        style: normalizeStyle(rootStyle.value),
        "can-animate": !unref(store)?.handlers.isFirstStep,
        "data-testid": "steps",
        "aria-label": unref(t)("Main content")
      }, [
        _ctx.layoutKind === unref(ToolLayoutKind).SquareImage && _ctx.imagePosition === "top" ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "thn--tool-steps__container",
          style: normalizeStyle(containerStyle.value)
        }, null, 4)) : createCommentVNode("", true),
        (openBlock(true), createElementBlock(Fragment, null, renderList(stepIds.value, (stepId) => {
          return openBlock(), createElementBlock("section", {
            class: normalizeClass(`thn--tool-steps__step thn--tool-steps__step--${stepId}`),
            state: getStepState(stepId),
            key: stepId,
            "data-add-module": stepId === unref(DefaultStep).Main && stepId === unref(store)?.handlers.stepActive,
            "data-vertical-center": _ctx.layoutKind === unref(ToolLayoutKind).SquareImage && stepId === "main",
            "data-image-position": _ctx.imagePosition,
            "data-horizontal-layout": _ctx.isHorizontalLayout,
            "data-align": _ctx.moduleAlign,
            inert: getStepState(stepId) !== unref(StepState).Active
          }, [
            _ctx.texts && _ctx.isHorizontalLayout ? (openBlock(), createElementBlock("section", _hoisted_3, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.texts[stepId], (subModule, subIndex) => {
                return openBlock(), createBlock(resolveDynamicComponent(getModuleComponent(subModule.moduleType)), mergeProps({
                  key: `${subIndex}-${subIndex}`,
                  class: "thn--tool-steps__step-component",
                  "has-extra-steps": _ctx.hasExtraSteps,
                  "aria-live": _ctx.hasExtraSteps ? "assertive" : "off",
                  layout: _ctx.layout,
                  ref_for: true
                }, { moduleProps: subModule }), null, 16, ["has-extra-steps", "aria-live", "layout"]);
              }), 128))
            ])) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.steps[stepId], (moduleProps, moduleIndex) => {
              return openBlock(), createBlock(resolveDynamicComponent(getModuleComponent(moduleProps.moduleType)), mergeProps({
                class: "thn--tool-steps__step-component",
                key: moduleIndex,
                "has-extra-steps": _ctx.hasExtraSteps,
                "aria-live": _ctx.hasExtraSteps ? "assertive" : "off",
                "is-horizontal-layout": _ctx.isHorizontalLayout,
                "modal-root-container": _ctx.modalRootContainer,
                layout: _ctx.layout,
                ref_for: true
              }, {
                moduleProps
              }), null, 16, ["has-extra-steps", "aria-live", "is-horizontal-layout", "modal-root-container", "layout"]);
            }), 128))
          ], 10, _hoisted_2);
        }), 128))
      ], 12, _hoisted_1);
    };
  }
});

export { StepState as S, _sfc_main as _, countdownFontSizes as c };
//# sourceMappingURL=Steps.vue_vue_type_style_index_0_lang.C4lMIBY7.js.map
